var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterventionalCardiology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M9.123,8.171L8.421,7.745l-1.47-0.684 L5.043,9.956c0,0,3.843,1.231,2.954,4.429c-0.89,3.197,0.246,6.083,2.397,8.515c0,0,0.673,0.685,1.88,1.493l3.607-2.86l3.64-2.952 l2.945-2.474c-0.471-2.292-2.083-7.5-6.994-7.36"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M11.1,13.409c0,0-3.051-1.896-1.709-5.36 L7.989,7.278l0.578-1.372l1.402,0.771l0.653-0.89L9.739,4.541L11,3.754l0.786,1.261l1.061-0.163l0.178-1.41l1.394,0.082 l-0.259,1.52c0,0,0.415,0.134,0.667,0.49"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M9.095,14.665c0,0,2.381-0.027,2.338-2.581 c0,0-0.267-7.027,5.224-8.16c0,0,1.948-0.312,3.441,0.277l-0.613,3.194c0,0-2.816-0.705-4.076,1.149 c-1.018,1.498-0.928,4.667,1.239,6.478"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A4B1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M8.292,24.95c0,0,8.876-3.391,15.016-12.193 c0,0,0.556-0.874,2.229-0.385c0,0,1.77,0.416,2.286,2.067c0,0,0.169,0.504-0.179,0.951c0,0-4.952,8.461-16.585,13.875l-0.392-0.463 c0,0,0.565-0.486,0.55-1c0,0,0.044-1.391-1.281-2.01c0,0-0.582-0.42-1.347-0.188L8.292,24.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M24.422,14.688c0,0,1.665-2.261,2.106-3.158 c0,0,0.178-0.486,0.521-0.337c0,0,0.297,0.142,0.016,0.545c0,0-1.558,2.561-2.164,3.271c0,0-0.592,0.906-0.831,1.404 c0,0-0.444,1.551-3.819,4.484c0,0-3.317,3.125-5.767,3.875l-1.005,0.506c0,0-3.341,1.822-4.979,2.377c0,0-0.616,0.018-0.218-0.482 c0,0,1.477-0.525,4.241-2.051c0,0,1.034-0.41,1.966-1.428c0,0,4.56-4.008,6.039-5.229c0,0,1.842-1.863,2.788-2.625l0.748-0.658 L24.422,14.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M24.371,14.647l0.604,0.422 c0,0-0.039,0.299-0.325,0.483l-0.662-0.429C23.988,15.124,24.028,14.758,24.371,14.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M13.082,24.706l0.467,0.648 c0,0-0.155,0.258-0.55,0.324l-0.503-0.654C12.496,25.024,12.74,24.718,13.082,24.706z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    x1: 13.371,
    y1: 24.651,
    x2: 23.164,
    y2: 15.968
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M23.226,15.94c0,0-2.582,4.207-4.208,6.025"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M19.182,21.778 c-0.952,0.689-4.444,2.371-4.444,2.371s3.12-2.814,3.443-3.676"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M22.011,16.991c0,0-2.241,3.773-5.412,6.748"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M15.006,24.583c0,0,3.505-3.086,5.297-5.928"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M21.065,20.165c0,0,1.761-2.46,2.475-3.867 c0,0-2.728,2.441-4.085,3.076"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M17.291,21.243c0,0,4.306-2.309,6.744-4.734"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M15.684,22.603c0,0,4.263-2.021,7.599-4.85"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M14.44,23.749c0,0,4.468-2.025,6.853-3.908"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2DA",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.589,25.604c0,0,2.945-1.479,3.61-1.645 c0,0,0.384-0.201,0.761-0.217c0,0,0.755,0.01,1.348-0.701l0.67-0.398l0.891-0.516c0,0,1.826-0.492,3.196-2.18 c0,0,0.702-0.789,0.984-1.322c0,0,0.156-0.301,0.649-0.605c0,0,0.604-0.441,1.072-1.683c0,0,0.41-0.794,0.631-1.14l1.519-2.066 l-0.613-0.376c0,0-2.601,3.584-4.007,4.734c0,0-5.16,5.18-11.009,7.459L8.589,25.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M10.114,24.354c0,0,2.4-1.139,3.757-2.119 c0,0,1.034-0.767,1.812-1.235c0,0,1.222-0.822,2.346-1.897c0,0,2.068-2.166,2.894-3.033l2.172-2.419c0,0-1.353,1.607-1.435,2.376 c0,0,0.047,0.586-0.905,1.627c0,0-1.192,1.004-1.387,1.529c0,0-0.735,1.021-2.465,2.338c0,0-0.845,0.443-1.64,0.742 c0,0-0.674,0.057-0.922,0.529c0,0-0.417,0.549-1.25,0.666L10.114,24.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D98A"
    },
    d: "M13.873,22.495c0,0,1.35-1.027,1.736-1.232c0,0,1.485-0.793,2.626-2.25c0,0,2.109-2.203,2.547-2.488 c0,0,0.03,1.19-0.514,1.48c0,0-0.524,0.396-0.788,0.775c0,0-0.514,0.756-0.666,0.934c0,0-1.233,1.607-2.445,1.947 c0,0-1.141,0.496-1.697,0.574L13.873,22.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2DA",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M10.667,28.802c0,0,3.451-1.631,4.07-2.475 c0,0,1.466-2.084,2.67-2.953c0,0,1.894-1.623,2.901-2.285c0,0,3.331-2.422,3.524-2.51c0,0,1.208-0.73,1.626-1.441l1.601-2.078 l0.584,0.33c0,0-2.641,3.908-4.372,5.359c0,0-4.599,5.147-12.213,8.516L10.667,28.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.15,
      strokeMiterlimit: 10
    },
    d: "M14.905,26.761c0,0,0.591-0.594,0.819-1.217 c0,0,0.062-0.422,0.551-0.566c0,0,0.417-0.221,0.529-0.783c0,0,0.302-0.723,0.967-0.986c0,0,0.395-0.119,0.702-0.072 c0,0,0.301,0.076,0.483-0.344c0,0,0.211-1.047,1.178-1.465c0,0,0.46-0.158,0.699-0.184c0,0,1.107-0.297,1.489-0.731 c0,0,0.415-0.447,0.49-0.668c0,0,0.229-0.434,0.778-0.664c0,0,1.099-0.764,1.481-1.065c0,0,0.55-0.414,0.198,0.154 c0,0-0.783,0.99-1.76,1.812c0,0-0.288,0.262-0.781,0.844c0,0-1.545,1.668-2.254,2.119c0,0-1.689,1.18-2.039,1.607 c0,0-0.283,0.465-1.383,1.072L14.905,26.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D98A"
    },
    d: "M16.802,25.589c0,0-1.104,0.205-0.772-0.195c0,0,0.049-0.174,0.442-0.318 c0,0,0.333-0.25,0.455-0.871c0,0,0.133-0.812,1.395-0.938c0,0,0.633,0.152,0.769-0.488c0,0,0.181-1.064,1.309-1.438 c0,0,1.727-0.318,2.282-1.188c0,0,0.313-0.611,0.765-0.836l0.598-0.391c0,0,0.413-0.045-0.348,0.701c0,0-0.836,0.66-1.457,1.496 c0,0-1.068,1.32-2.392,2.129c0,0-1.265,0.883-1.55,1.309C18.298,24.562,17.786,25.261,16.802,25.589z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterventionalCardiology);
export default __webpack_public_path__ + "static/media/interventional_cardiology.58ab38b06070854044238ebf46405c41.svg";
export { ForwardRef as ReactComponent };